

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"name":"Français","code":"fr-CA","iso":"fr-CA","file":"fr-CA.js"},{"name":"Anglais","code":"en-CA","iso":"en-CA","file":"en-CA.js"}],
  defaultLocale: "fr-CA",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/usr/src/nuxt-app/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: true,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  loadLanguagesAsync: true,
  fallbackLocale: "fr-CA",
  normalizedLocales: [{"name":"Français","code":"fr-CA","iso":"fr-CA","file":"fr-CA.js"},{"name":"Anglais","code":"en-CA","iso":"en-CA","file":"en-CA.js"}],
  localeCodes: ["fr-CA","en-CA"],
}

export const localeMessages = {
  'fr-CA.js': () => import('../../locales/fr-CA.js' /* webpackChunkName: "lang-fr-CA.js" */),
  'en-CA.js': () => import('../../locales/en-CA.js' /* webpackChunkName: "lang-en-CA.js" */),
}
